<template>
  <div class="fill">
    <v-row v-if="!iSingle && type == 'roteiro'">
      <v-col
        align-self="center"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        v-for="(info, index) in informations"
        :key="index"
      >
        <div class="fillw d-flex justify-center">
          <v-card class="my-12 mx-5 fill" height="350px">
            <v-img class="white--text align-end" height="200px" :src="info.imagem"></v-img>

            <v-card-subtitle class="pb-0">
              <div class="subtitle-1 red--text text-truncate">{{info.categoria_nome}}</div>
            </v-card-subtitle>

            <v-card-text class="text--primary pb-0">
              <div class="title gray--text text-truncate">{{info.nome}}</div>
            </v-card-text>

            <v-card-actions class="card-actions">
              <v-btn
                @click="goTo('roteiro/',info.roteiro_id)"
                class="ml-2"
                dark
                color="#dd2129"
              >{{btnText}}</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="!iSingle && type == 'noticia'">
      <v-col
        align-self="center"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        v-for="(info, index) in informations"
        :key="index"
      >
        <div class="fillw d-flex justify-center">
          <v-card class="mx-5 fill" height="350px">
            <v-img class="white--text align-end" height="200px" :src="info.imagem"></v-img>

            <v-card-subtitle class="pb-0">
              <div class="subtitle-1 red--text text-truncate">{{info.categoria_nome}}</div>
            </v-card-subtitle>

            <v-card-text class="text--primary pb-0">
              <div class="title gray--text text-truncate">{{info.nome}}</div>
            </v-card-text>

            <v-card-text class="text--primary pb-0 pt-0">
              <div class="subtitle-2 gray--text text-truncate">{{info.data}}</div>
            </v-card-text>

            <v-card-actions class="card-actions">
              <v-btn
                @click="goTo('noticia/',info.noticia_id)"
                class="ml-2"
                dark
                color="#dd2129"
              >{{btnText}}</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="!iSingle && type == 'evento'">
      <v-col
            align-self="center"
            cols="12"
            sm="6"
            md="6"
            lg="4"
            v-for="(info, index) in informations"
            :key="index"
          >
            <div class="fillw d-flex justify-center">
              <v-card class="mx-5 fill" height="350px">
                <v-img class="white--text align-end" height="200px" :src="info.imagem"></v-img>

                <v-card-subtitle class="pb-0">
                  <div class="subtitle-1 red--text text-truncate">{{info.categoria_nome}}</div>
                </v-card-subtitle>

                <v-card-text class="text--primary pb-0">
                  <div class="title gray--text text-truncate">{{info.nome}}</div>
                </v-card-text>

                <v-row class="text--primary ml-4 mr-4">
                  <div class="subtitle-2 gray--text text-truncate">{{info.data_inicio}}</div>
                  <v-spacer></v-spacer>
                  <div class="subtitle-2 gray--text text-truncate">{{info.data_fim}}</div>
                </v-row>

                <v-card-actions class="card-actions">
                  <v-btn
                    @click="goTo('evento/',info.evento_id)"
                    class="ml-2"
                    dark
                    color="#dd2129"
                  >{{btnText}}</v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "ComponentCard",
  props: ["type", "informations", "btnText", "iSingle"],
  methods: {
    goTo(routeName, id) {
      var lang = "/" + this.$store.getters.language + "/";

      if (_.isNull(id)) {
        this.$router.push({ path: lang + routeName });
      } else {
        this.$router.push({ path: lang + routeName + id });
      }
    }
  },
  async mounted() {}
};
</script>
